<template>
  <SeoPage page-key="marketingDigitaleTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'MarketingDigitaleTicinoPage'
})
</script>

